<script setup lang="ts">
import { useOverlay } from './use-overlay';

const { overlays, close, unmount } = useOverlay();

const onOpenUpdate = (id: string, open: boolean): void => {
  if (!open) {
    close(id);
  }
};
</script>

<template>
  <component
    :is="instance.component"
    v-for="instance in overlays"
    :key="instance.id"
    v-bind="instance.props"
    :open="instance.open"
    @update:open="onOpenUpdate(instance.id, $event)"
    @close="close(instance.id, $event)"
    @after:leave="unmount(instance.id)"
  />
</template>
